<template>
  <v-app>
    <router-view></router-view>
    <v-dialog
      v-model="msg_dialog.status"
      persistent
      max-width="300"
      overlay-opacity="1"
    >
      <v-card elevation="12">
        <v-card-title>
          <v-row align="center" justify="center" class="mt-1">
            <v-col class="text-center">
              <v-icon size="100" color="error">mdi-alert</v-icon>
            </v-col>
          </v-row>
        </v-card-title>
        <v-card-text>
          <v-row justify="center" align="center">
            <v-col class="text-center pt-0"
              ><b
                ><p>{{ msg_dialog.msg }}</p></b
              ></v-col
            >
          </v-row>
          <v-row justify="center" align="center">
            <v-col class="text-center">
              <v-btn color="success" elevation="6" small @click="reload()"
                >โหลดหน้าเว็บใหม่อีกครั้ง</v-btn
              >
            </v-col>
          </v-row>
        </v-card-text>
      </v-card>
    </v-dialog>
  </v-app>
</template>

<script>

export default {
  name: "App",
  data: () => ({
    msg_dialog: {
      status: false,
      msg: "",
    },
  }),
  created() {
    this.checkVersion().then(() => {
      this.checkLogin();
    });
  },
  methods: {
    // เช็คการเข้าสู่ระบบ
    checkLogin() {
      if (localStorage.getItem("hml_portal_username") === null) {
        if (location.pathname !== "/data_portal/" && location.pathname.split("/")[2] !== "sales") {
          this.$router.push("/");
        }
      } else {
        if (location.pathname === "/data_portal") {
          this.$router.push("/search-for-sales");
        }
      }
    },
    // เช็คเวอร์ชันการใช้งานเว็บ
    checkVersion() {
      return this.$axios
        .post(this.api + "/version", { version: this.version })
        .then((res) => {
          if (!res.data.status) {
            this.msg_dialog.status = true;
            this.msg_dialog.msg = res.data.msg;
          }
        });
    },
    // โหลดหน้าเว็บใหม่
    reload() {
      location.reload();
    },
  },
};
</script>
<style>
@import url("https://fonts.googleapis.com/css2?family=Kanit:wght@300&display=swap");
* {
  font-family: "Kanit", sans-serif !important;
}
</style>